function moveModals(container) {
  const modals = container.querySelectorAll('[data-modal]');
  const modalBin = document.querySelector('[data-modal-container]');
  modals.forEach((element) => {
    const alreadyAdded = modalBin.querySelector(`[id="${element.id}"]`);
    if (!alreadyAdded) {
      modalBin.appendChild(element);
    }
  });
}

export default moveModals;
